/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import Icon, { ICON_TYPES } from '@commons/Icon';

import { cookieBannerVersionPropType, isV1 } from '@components/CookieBanner/shared/utils';

import styles from './cookieBannerPanelLink.scss';

const CookieBannerPanelLink = forwardRef(({ version, onClick, children, id }, ref) => (
  <button className={styles.anchor} onClick={onClick} ref={ref}>
    {/* eslint-disable-next-line react/no-danger */}
    <span dangerouslySetInnerHTML={{ __html: children }} />
    {isV1(version) && <Icon type={ICON_TYPES.ARROW_RIGHT} />}
  </button>
));

CookieBannerPanelLink.propTypes = {
  version: cookieBannerVersionPropType.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};
export default CookieBannerPanelLink;
